import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ItemsContainerComponent } from '@shared/components/itemsContainer';
const ProductsComponent = ({ productsItems, tooltipTitle, textSize = 'medium', wrap = false, withText = false, withTooltip = false, linkedAddIns = null, linkedWebApps = null })=>{
    const items = React.useMemo(()=>productsItems.map((item)=>{
            return {
                icons: [
                    item.urlKey
                ],
                title: item.title
            };
        }), [
        productsItems
    ]);
    return /*#__PURE__*/ _jsx(ItemsContainerComponent, {
        items: items,
        textSize: textSize,
        tooltipTitle: tooltipTitle,
        withText: withText,
        withTooltip: withTooltip,
        wrap: wrap,
        withDivider: false,
        linkedAddIns: linkedAddIns,
        linkedWebApps: linkedWebApps
    });
};
export default ProductsComponent;
